<template>
  <el-dialog
          title="选择岗位"
          :close-on-click-modal="false"
          width="60%"
          :visible.sync="visible">
    <div style="text-align: center;">
      <el-transfer
              style="text-align: left;display: inline-block"
              :titles="titles"
              filterable
              filter-placeholder=""
              v-model="selectIds"
              :data="dataList">
      </el-transfer>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取消
      </el-button>
      <el-button size="small" type="primary" @click="dataFormSubmit()">确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {fetchPositionForUser, assignPositionForUser} from '@/controller/sys'
  export default {
    data () {
      return {
        titles: ['岗位列表', '已关联'],
        dataForm: {
          id: ''
        },
        dataList: [],
        selectIds: [],
        oldSelection: [],
        visible: false
      }
    },
    methods: {
      init(id, ids) {
        this.dataForm.id = id
        this.dataList = []
        this.selectIds = []
        this.visible = true
        fetchPositionForUser({},sessionStorage.getItem('mainBodyId')).then(data => {
          if (data && data.code === '00') {
            data.body.forEach((item, idx) => {
              this.dataList.push({
                label: item.positionName,
                key: item.id,
                index: idx
              })
            })
            this.selectIds = ids
            this.oldSelection = ids
          } else {
            this.dataList = []
          }
          this.dataListLoading = false
        })
      },
      dataFormSubmit() {
        let insertIds = []
        let deleteIds = []
        this.selectIds.forEach(item => {
          let isNew = true
          this.oldSelection.forEach(selection => {
            if(selection === item){
              isNew = false
              return
            }
          })
          if(isNew){
            insertIds.push(item)
          }
        })
        this.oldSelection.forEach(item => {
          let isOld = true
          this.selectIds.filter(selection => {
            if(selection === item){
              isOld = false
              return
            }
          })
          if(isOld){
            deleteIds.push(item)
          }
        })
        assignPositionForUser(
                {
                  'userId': this.dataForm.id || undefined,
                  'insertIds': insertIds,
                  'deleteIds': deleteIds
                }
        ).then(data => {
          if (data && data.code === '00') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          }
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
</script>
